import React, { Component } from 'react';


export default class Comment extends Component {
  render() {
    let comment = this.props.commentData;
    let classes = this.props.styleClasses ? this.props.styleClasses : '';
    let quotes = this.props.quotesElement ? this.props.quotesElement : '';
    return (
      <li className={'review clearfix ' + classes[0]}>
        <img className={'review__avatar'} src={comment.commentAuthorView.pictureUrl} alt={comment.commentAuthorView.fullName} />
        <div className='review__column '>
          <div className={'review__author ' + classes[2]}>{comment.commentAuthorView.fullName}</div>
          <div className={'review__from ' + classes[2]}>
            <span className='review__org'>{comment.commentAuthorView.companyName}, </span>
            <span className='review__activities'>{comment.commentAuthorView.jobPosition}, </span>
            <span className='review__city'>{comment.commentAuthorView.city.name}</span>
          </div>
          <div className={'review__text ' + classes[1]}>
            <p>{quotes[0]}{comment.commentText}{quotes[1]}</p>
          </div>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/comment/Comment.js